import React, { useEffect, useState } from "react";
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
	dateFormatter,
	buttonsStyle,
	booleanFormatter,
} from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import {
	getSessions,
	deleteSession,
	activateSession,
	duplicateSession,
} from "../../../../api/session";
import { Button, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import { useIsAdmin } from "../../../hooks/useIsAdmin";

function getData(sessions) {
	let data = [];
	for (let i = 0; i < sessions.length; ++i) {
		const elem = {};
		elem.name = sessions[i].name;
		elem.code = sessions[i].code;
		elem.active = sessions[i].active;
		elem.demo = sessions[i].demo;
		elem.phase = sessions[i].phase;
		elem.numTables = sessions[i].numTables;
		elem.createdAt = sessions[i].createdAt;
		elem.id = sessions[i]._id;
		data = data.concat(elem);
	}
	return data;
}

export default function SessionsPage() {
	const [data, setData] = useState([]);
	const [sessionId, setSessionId] = useState(null);
	const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
	const [openActivateDialog, setOpenActivateDialog] = useState(false);
	const [refresh, setRefresh] = useState(false);
	const history = useHistory();
	const isAdmin = useIsAdmin();

	function buttonFormatter(cell, row) {
		return (
			<>
				{isAdmin && (
					<Tooltip title="Activar">
						<span>
							<Button
								style={buttonsStyle}
								size="small"
								disabled={row.active}
								onClick={() => {
									setSessionId(cell);
									setOpenActivateDialog(true);
								}}
							>
								<PlayArrowIcon />
							</Button>
						</span>
					</Tooltip>
				)}
				<Tooltip title="Ver seguimiento">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={() => history.push("/session/" + cell)}
					>
						<VisibilityIcon />
					</Button>
				</Tooltip>
				{isAdmin && (
					<>
						<Tooltip title="Editar">
							<Button
								style={buttonsStyle}
								size="small"
								onClick={() => history.push("/edit-session/" + cell)}
							>
								<EditIcon />
							</Button>
						</Tooltip>
						<Tooltip title="Duplicar">
							<Button
								style={buttonsStyle}
								size="small"
								onClick={() => handleDuplicate(cell)}
							>
								<FileCopyIcon />
							</Button>
						</Tooltip>
						<Tooltip title="Eliminar">
							<Button
								style={buttonsStyle}
								size="small"
								onClick={() => {
									setSessionId(cell);
									setOpenConfirmDialog(true);
								}}
							>
								<DeleteIcon />
							</Button>
						</Tooltip>
					</>
				)}
			</>
		);
	}

	function handleDuplicate(id) {
		duplicateSession(id)
			.then((res) => {
				if (res.status === 201) {
					alertSuccess({
						title: "Duplicada",
						customMessage: "Sesión duplicada correctamente.",
					});
					setRefresh(true);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "No se ha podido duplicar la sesión.",
				});
			});
	}

	function handleActivate() {
		activateSession(sessionId)
			.then((res) => {
				if (res.status === 200) {
					alertSuccess({
						title: "Activada",
						customMessage: "La sesión es ahora la activa.",
					});
					setRefresh(true);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "No se ha podido activar la sesión.",
				});
			});
	}

	const columns = [
		{ dataField: "name", text: "Nombre", sort: true },
		{ dataField: "code", text: "Código", sort: true },
		{
			dataField: "active",
			text: "Activa",
			formatter: booleanFormatter,
			sort: true,
		},
		{
			dataField: "demo",
			text: "Demo",
			formatter: booleanFormatter,
			sort: true,
		},
		{ dataField: "phase", text: "Fase actual", sort: true },
		{ dataField: "numTables", text: "Nº mesas", sort: true },
		{
			dataField: "createdAt",
			text: "Creada",
			formatter: dateFormatter,
			sort: true,
		},
		{
			dataField: "id",
			text: "",
			formatter: buttonFormatter,
			searchable: false,
		},
	];

	useEffect(() => {
		getSessions()
			.then((res) => {
				if (res.status === 200) {
					setData(getData(res.data));
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "No se han podido cargar las sesiones.",
				});
			});
	}, [refresh]);

	return (
		<>
			<Card>
				<CardHeader title="Sesiones">
					{isAdmin && (
						<CardHeaderToolbar>
							<button
								type="button"
								className="btn btn-primary"
								onClick={() => history.push("/edit-session")}
							>
								Nueva sesión
							</button>
						</CardHeaderToolbar>
					)}
				</CardHeader>
				<CardBody>
					<Table data={data} columns={columns} />
					<ConfirmDialog
						title={"¿Seguro que quieres eliminar esta sesión?"}
						open={openConfirmDialog}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							deleteSession(sessionId)
								.then((res) => {
									if (res.status === 204 || res.status === 200) {
										alertSuccess({
											title: "Eliminada",
											customMessage:
												"Sesión eliminada correctamente.",
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage:
											"No se ha podido eliminar la sesión.",
									});
								});
						}}
					>
						{
							"Se borrarán también sus mesas, respuestas, expectativas y respuestas de encuesta."
						}
					</ConfirmDialog>
					<ConfirmDialog
						title={"¿Activar esta sesión?"}
						open={openActivateDialog}
						setOpen={setOpenActivateDialog}
						onConfirm={handleActivate}
					>
						{
							"Las tablets, la pantalla y la encuesta pasarán a usar esta sesión. Las demás quedarán desactivadas."
						}
					</ConfirmDialog>
				</CardBody>
			</Card>
		</>
	);
}
